import { convertTo12Hour } from "functions";
import { fadeIn } from "animations";
import { motion, AnimatePresence } from "motion/react";
import { calendarSvg, peopleSvg, clockSvg } from "svg";
import { dateToString } from "dateUtils";

function FoundTable(props) {
  const { table, setEditing, inRes, onSave } = props;
  const { numGuests, date, time } = table;

  console.log(table);

  return (
    <AnimatePresence>
      <motion.div
        layout
        {...fadeIn}
        className={inRes ? "inResTable" : "found-table-standalone"}
      >
        {inRes ? (
          <div className="found-table-header found-table-header-inres">
            <div className="found-table-eyebrow">Your updated reservation</div>
            <button
              className="edit-btn found-table-edit-inline"
              type="button"
              onClick={() => setEditing(true)}
            >
              Change
            </button>
          </div>
        ) : (
          <div className="found-table-header">
            <div className="found-table-title">Your table</div>
            <button
              className="edit-btn found-table-edit-inline"
              type="button"
              onClick={() => setEditing(true)}
            >
              Change
            </button>
          </div>
        )}
        <div className="found-table found-table-elegant">
          <div className="table-info">
            <span className="table-info-icon">{peopleSvg()}</span>
            <span className="table-info-label">Party</span>
            <span className="table-info-value">{numGuests}</span>
          </div>
          <div className="table-info">
            <span className="table-info-icon">{calendarSvg()}</span>
            <span className="table-info-label">Date</span>
            <span className="table-info-value">{dateToString(date)}</span>
          </div>
          <div className="table-info">
            <span className="table-info-icon">{clockSvg()}</span>
            <span className="table-info-label">Time</span>
            <span className="table-info-value">{convertTo12Hour(time)}</span>
          </div>
        </div>
        {inRes && onSave && (
          <div className="found-table-actions">
            <button
              className="submit-button save-modify-btn"
              type="button"
              onClick={() => onSave(table)}
            >
              Save
            </button>
          </div>
        )}
        {!inRes && (
          <div style={{ paddingTop: "15px" }}>
            <span className="reserve-small-text" style={{ fontWeight: "400" }}>
              • Your reservation will be held for{" "}
              <span style={{ fontWeight: "800", fontSize: "17px" }}>
                {" "}
                10 minutes.{" "}
              </span>{" "}
              Please contact us by phone if your party is running late.{" "}
            </span>
          </div>
        )}
      </motion.div>
    </AnimatePresence>
  );
}

export default FoundTable;
